import React from 'react';
import './Emergency.css';

import { Heading, PageTitle, Service } from '../../components';
import { Banner, FAQs, WhyChooseUs } from '../../sections';
import { emergencyIntro, emergencyServices, emergencyFaqs } from '../../constants';

import { FaLock } from 'react-icons/fa';



const Emergency = () => {
  return (
    <>
        {/* Page Title Section */}
        <PageTitle title={'Emergency Services'} page={'Emergency Services'} />

        <section className='emergency-page'>

            {/* Emergency Introduction Section */}
            <section className='emergency-intro'> 

                <div className='image'>
                    <img src={emergencyIntro.image.src} alt={emergencyIntro.image.alt} /> {/* Emergency Intro Image */}
                </div>

                {/* Emergency Intro Content */}
                <div className='content'>

                    {/* Section Heading */}
                    <Heading title={emergencyIntro.heading} subTitle={emergencyIntro.sub} sideHeading={true} />

                    {/* Emergency Description */}
                    <p>{emergencyIntro.description}</p>

                    {/* Key Features List */}
                    <ul className="emergency-features">
                        {emergencyIntro.points.map((point, index) => (
                        <li key={index}>
                            <div className='icon'><FaLock /></div> {/* Lock Icon */}
                            <span>{point}</span> {/* Feature Title */}
                        </li>
                        ))}
                    </ul> 

                </div>

            </section>

            {/* Banner Section */}
            <Banner />

            {/* Emergency Services Section */}
            <section className='services'>

                {/* Section heading */}
                <Heading title={'Emergency Services'} subTitle={'what we offer'} />

                <div className='box-container'>

                {/* Map over the services array to render each service */}
                {emergencyServices.map((service) => { 
                    return (
                    <Service key={service.id} service={service} />
                    );
                })}

                </div>

            </section>

            {/* Why Choose Us Section */}
            <WhyChooseUs />

            {/* Emergency FAQs Section */}
            <FAQs faqsContent={emergencyFaqs} />

        </section>

    </>
  )
};

export default Emergency;